// Copyright (c) 2016 Deere & Company

import Accordion from './components/accordion';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = (state, ownProps) => ({
    ...ownProps
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(Accordion);




// WEBPACK FOOTER //
// ./src/shared/components/smart-accordion/index.js